import PropTypes from 'prop-types'
import React from 'react'

export const RegistrationPriceMobile = ({price}) => price ? (
  <div className='oglasi-opis'>
    <div className='oglasi-info-heading'>
      <p>Cijena registracije</p>
    </div>
    <p>Cijena registracije za ovo vozilo na premijski razred 7 iznosi oko <span className='registracija-info-cijena'>{price} &euro;</span>
    </p>
  </div>
) : null

RegistrationPriceMobile.propTypes = {
  price: PropTypes.string
}
